'use client';

import Link from 'next/link';
import { MessageCircle, Mail } from 'lucide-react';
import { useLanguage } from '@/hooks/use-language';

const WHATSAPP_NUMBER = '966500000000'; // TODO: replace with real number
const EMAIL = 'hello@momira.app'; // TODO: replace with real email

export default function ContactPage() {
  const { lang } = useLanguage();
  const isAr = lang === 'ar';

  const waMsg = encodeURIComponent(isAr ? 'مرحبا، أريد الاستفسار عن Momira' : 'Hi, I have a question about Momira');

  return (
    <div className="min-h-screen bg-background text-white" dir={isAr ? 'rtl' : 'ltr'}>
      <header className="sticky top-0 z-50 border-b border-zinc-900 bg-background/80 backdrop-blur-md">
        <div className="max-w-3xl mx-auto px-6 h-14 flex items-center">
          <Link href="/" className="text-lg font-bold">Momira</Link>
        </div>
      </header>

      <main className="max-w-lg mx-auto px-6 py-16 text-center space-y-10">
        <div>
          <h1 className="text-3xl font-bold mb-3">{isAr ? 'تواصل معنا' : 'Contact Us'}</h1>
          <p className="text-zinc-400">
            {isAr
              ? 'هل لديك سؤال أو اقتراح؟ نحن هنا للمساعدة.'
              : 'Have a question or suggestion? We\'re here to help.'}
          </p>
        </div>

        <div className="grid gap-4">
          {/* WhatsApp */}
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${waMsg}`}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-center gap-3 h-14 rounded-2xl border border-emerald-500/30 bg-emerald-500/10 text-emerald-400 hover:bg-emerald-500/20 transition-colors font-semibold"
          >
            <MessageCircle className="h-5 w-5" />
            {isAr ? 'تواصل عبر واتساب' : 'Chat on WhatsApp'}
          </a>

          {/* Email */}
          <a
            href={`mailto:${EMAIL}`}
            className="flex items-center justify-center gap-3 h-14 rounded-2xl border border-zinc-700 bg-zinc-900/40 text-zinc-300 hover:border-zinc-500 transition-colors font-medium"
          >
            <Mail className="h-5 w-5" />
            {EMAIL}
          </a>
        </div>

        <div className="rounded-2xl border border-zinc-800 bg-zinc-900/30 p-6 text-start space-y-3">
          <h2 className="font-semibold text-white">{isAr ? 'لأسئلة القاعات والمصورين' : 'For venues & photographers'}</h2>
          <p className="text-zinc-400 text-sm">
            {isAr
              ? 'إذا كنت تدير قاعة مناسبات أو تعمل مصورًا وتريد معرفة المزيد عن الباقات المخصصة، تواصل معنا مباشرة عبر واتساب.'
              : 'If you manage an event venue or work as a photographer and want to learn about custom plans, reach out via WhatsApp.'}
          </p>
          <a
            href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(isAr ? 'مرحبا، أريد الاستفسار عن باقة القاعات/المصورين' : 'Hi, I want to ask about venue/photographer plans')}`}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:underline"
          >
            <MessageCircle className="h-4 w-4" />
            {isAr ? 'اطلب تجربة مجانية للقاعة' : 'Request a free venue trial'}
          </a>
        </div>
      </main>

      <footer className="py-8 px-6 border-t border-zinc-900 text-center text-sm text-zinc-500">
        <div className="flex flex-wrap justify-center gap-4">
          <Link href="/privacy" className="hover:text-zinc-300">{isAr ? 'الخصوصية' : 'Privacy'}</Link>
          <Link href="/terms" className="hover:text-zinc-300">{isAr ? 'الشروط' : 'Terms'}</Link>
          <Link href="/contact" className="hover:text-zinc-300">{isAr ? 'تواصل معنا' : 'Contact'}</Link>
        </div>
      </footer>
    </div>
  );
}
